import { Component, ChangeDetectionStrategy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";

export interface LogoutConfirmationDialogContext {
}

@Component({
    templateUrl: "./logout-confirmation.component.html",
    styleUrls: ["./logout-confirmation.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class AdminLogoutConfirmationDialogComponent {

    constructor(public modal: NgbActiveModal) {
    }
}
